import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

import Xpeer from '../HomeLite/patterns/Xpeer/Xpeer';

import Hero from './patterns/Hero/Hero';
import DownloadApp from './patterns/DownloadApp/DownloadApp';
import Fees from './patterns/Fees/Fees';
import MSI from './patterns/MSI/MSI';
import FeaturesCarousel from './patterns/FeaturesCarousel/FeaturesCarousel';
import Benefits from './patterns/Benefits/Benefits';
import AppleAndGooglePay from './patterns/AppleAndGooglePay/AppleAndGooglePay';
import Requirements from './patterns/Requirements/Requirements';
import FAQ from './patterns/FAQ/FAQ';
import CardRates from './patterns/CardRates/CardRates';

const CreditCardLiteVersion = () => (
  <ParallaxProvider>
    <Hero />
    <DownloadApp />
    <Fees />
    <MSI />
    <FeaturesCarousel />
    <Benefits />
    <AppleAndGooglePay />
    <Requirements />
    <FAQ />
    <CardRates />
    <Xpeer mgm />
  </ParallaxProvider>
);

export default CreditCardLiteVersion;
